import { useStytch, useStytchSession } from '@stytch/react'
import { OnboardingResponse } from 'api/common/routes'
import { useQuery } from 'react-query'

export const OnboardingDataQueryKey = 'onboarding-data'

export interface OnboardingData {
  waitlistUserId: string
  conditions: { value: string; tagId: string }[]
  what_brings_you_to_allara: string
}

interface UseOnboardingDataInterface {
  onboardingData?: OnboardingData | null
  onboardingDataError?: unknown
  isLoadingOnboardingData: boolean
  refetchOnboardingData: () => Promise<void>
}

const useOnboardingData = (): UseOnboardingDataInterface => {
  const { session } = useStytchSession()
  const stytch = useStytch()

  const fetchOnboardingData = async (): Promise<
    OnboardingData | null | undefined
  > => {
    if (!session) {
      return
    }

    const tokens = stytch.session.getTokens()
    const accessToken = tokens ? tokens.session_jwt : undefined

    return fetch(`${process.env.REACT_APP_SERVER_URL}${OnboardingResponse}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    }).then(async (res) => {
      const data = await res.json()

      if (res.ok) {
        return data
      } else if (res.status === 404) {
        return null
      } else {
        return undefined
      }
    })
  }

  const {
    data: onboardingData,
    error: onboardingDataError,
    isLoading: isLoadingOnboardingData,
    refetch: refetchQuery,
  } = useQuery(OnboardingDataQueryKey, fetchOnboardingData)

  const refetchOnboardingData = async () => {
    await refetchQuery()
  }

  return {
    onboardingData,
    onboardingDataError,
    isLoadingOnboardingData,
    refetchOnboardingData,
  }
}

export default useOnboardingData
